'use client';

import { observer } from 'mobx-react-lite';
import { useUserContext } from '@instamenu/context-user';
import {
  Stack,
  Box,
  InlineAuth,
  TextInput,
  Label,
  Skeleton,
  Flex,
} from '@instamenu/ui-system-next';
import { themeVars } from '@instamenu/ui-vanilla-extract';

export const OrderUser = observer((props: { label?: string }) => {
  const { user, ready } = useUserContext();

  if (!ready) {
    return (
      <Stack style={{ gap: 16 }}>
        <Skeleton variant="text" width={'25%'} height={22} />
        <Flex style={{ gap: 16, justifyContent: 'space-between' }}>
          <Skeleton variant="rect" width={'50%'} height={themeVars.sizes.inputHeight.sm} />
          <Skeleton variant="rect" width={'50%'} height={themeVars.sizes.inputHeight.sm} />
        </Flex>
      </Stack>
    );
  }

  if (!user) {
    return <InlineAuth />;
  }

  return (
    <>
      <Label>{props.label ?? 'Your Name'}</Label>
      <Flex>
        <Box css={{ width: '50%', paddingRight: 6, margin: '8px 0' }}>
          <TextInput
            value={user.firstName ?? ''}
            data-id="first-name"
            onChange={(e) => user.update({ firstName: e.target.value })}
            placeholder="First"
          />
        </Box>
        <Box css={{ width: '50%', paddingLeft: 6, margin: '8px 0' }}>
          <TextInput
            data-id="last-name"
            value={user.lastName ?? ''}
            onChange={(e) => user.update({ lastName: e.target.value })}
            placeholder="Last"
          />
        </Box>
      </Flex>
    </>
  );
});
